<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.mobility.title')"
        :field-author-and-date="qualification.commentOnMobility"
        data-testid="admin-section-tabs-qualification-mobility"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.commentOnMobility"
            :placeholder="$t('profile.vetting.qualification.mobility.placeholder')"
            autogrow
            data-testid="vetting-mobility-comment-edition"
        ></VJoyTextarea>
        <TextField
            v-else
            :content="profileQualificationStore.qualificationUpdateForm.commentOnMobility"
            :replace-by="$t('profile.vetting.qualification.mobility.empty.placeholder')"
            data-testid="vetting-mobility-comment"
            truncate
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);
</script>
